import { acss } from '@adornis/chemistry/directives/acss';
import { css } from '@adornis/chemistry/directives/css';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design';
import { html, nothing } from 'lit';

export const IconButton = ({
  icon,
  background,
  color,
  tooltip,
  onClickHandler,
}: {
  icon: string;
  background?: string;
  color?: string;
  tooltip?: string;
  onClickHandler?: () => void;
}) => {
  const design = DesignSystem.currentTheme.getValue();
  background = background ?? design.colors.accent;
  color = color ?? '#fff';

  return html`
    <x-flex
      center
      crossaxis-center
      ${acss({
        padding: '8px 32px',
        borderRadius: '8px',
        background,
        color,
        border: `1px solid ${background}`,
        cursor: 'pointer',
        '&:hover': {
          transition: '200ms',
          color: background,
          background: color,
        },
      })}
      @click=${() => {
        onClickHandler?.();
      }}
    >
      <d-icon solid ${css({ color: 'inherit' })}> ${icon} </d-icon>
      ${tooltip ? html` <d-tooltip> ${tooltip} </d-tooltip> ` : nothing}
    </x-flex>
  `;
};
